import React, {useEffect, useState} from "react";
import _ from "lodash";
import Translate from "../Translate";
import {Grid, Message} from "semantic-ui-react";
import firebase from "firebase";
import axios from "axios";
import ScrollMenu from "react-horizontal-scrolling-menu";
import {UserVisitedPage} from "../../helpers/UserVisitedPage";
import {CreateRecordingAssignmentOptions} from "../../helpers/CreateRecordingAssignmentOptions";
import DialogFlashCard from "./DialogFlashCard";


function DialogFlashCardWrapper(
    {
        classLevel
    }
) {

    const languageOptions = [
        {key: 1, text: 'samoan', value: true},
        {key: 2, text: 'english', value: false}
    ];

    const [translationAssignment, setTranslationAssignment] = useState([]);
    const [samoanDefault, setSamoanDefault] = useState(true);
    const [flashCards, setFlashCards] = useState(null);
    const [assignmentNum, setAssignmentNum] = useState(null);
    const [difficultyLevel, setDifficultyLevel] = useState('medium');
    const [open, setOpen] = useState(false);
    const [startQuiz, setStartQuiz] = useState(false);
    const [rand, setRand] = useState(0);
    const [assignmentLength, setAssignmentLength] = useState(0);
    const [nextCardTimer, setNextCardTimer] = useState(10000);
    const [flipTimer, setFlipTimer] = useState(5000);
    const [assignmentOptions, setAssignmentOptions] = useState([]);
    const [assignmentsDB, setAssignmentsDB] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scrollMenu, setScrollMenu] = useState([]);
    const [intervalID, setIntervalID] = useState(null);
    const [timeoutID, setTimeoutID] = useState(null);
    const [questionSounds, setQuestionSounds] = useState([]);
    const [responseSounds, setResponseSounds] = useState([]);
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [assignmentChosen, setAssignmentChosen] = useState(false);
    const [soundActive, setSoundActive] = useState([])

    useEffect(() => {
        UserVisitedPage();

        async function fetchData() {
            let retrievedFileNames = [];
            await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogFCAssignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        retrievedFileNames.push(folderRef.location.path_.split('/')[3])

                    })
                }).catch(e => console.log(e));
            let tmpAssignments = [];
            for (let i = 0; i < retrievedFileNames.length; i++) {
                const assignments = firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogFCAssignments/' + retrievedFileNames[i]);
                await assignments.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        tmpAssignments.push(res.data);
                        setProgress(prevState => prevState + Math.round(100 / retrievedFileNames.length));
                        setProgressText('Loading assignments');
                    });

            }
            setAssignmentsDB(tmpAssignments);
            setAssignmentLength(translationAssignment.length);

            CreateRecordingAssignmentOptions(tmpAssignments, 1, 'dialogFCData')
                .then((res) => {
                    setAssignmentOptions(res)

                })

        }

        fetchData().then(() => setLoading(false)).catch(e => console.log(e))
    }, []);

    const handleAssignmentChange = (event, {value}) => {
        setProgress(0);
        setAssignmentNum(value);
        setAssignmentLength(assignmentsDB[value].length);
        setSamoanDefault(true);
        setStartQuiz(false);
        setRand(null);
        setTranslationAssignment(assignmentsDB[value]);
        clearTimeout(timeoutID);
        clearInterval(intervalID);
        setLoading(true);

        async function fetchData() {
            setAssignmentChosen(false);

            let retrievedQuestionSoundURLS = [];
            let retrievedResponseSoundURLS = [];
            let tmpSoundsActive = [];
            const allSounds = firebase.storage().ref().child('sounds');

            const retrievedCardFlipSound = allSounds.child('cardflip.mp3');

            for (let i = 0; i < assignmentsDB[value].length; i++) {
                let retrievedQuestion = [];
                let retrievedResponse = [];
                console.log(assignmentsDB)
                for (let n = 0; n < assignmentsDB[value][i].questionAudio.length; n++) {
                    if (assignmentsDB[value][i].questionAudio[n] === "") {
                        await retrievedCardFlipSound.getDownloadURL().then(url => {
                            retrievedQuestion.push(new Audio(url))
                        });
                        tmpSoundsActive.push(false)
                    } else {
                        await allSounds.child(assignmentsDB[value][i].questionAudio[n]).getDownloadURL()
                            .then(url=>{
                                retrievedQuestion.push(new Audio(url))
                            })
                        tmpSoundsActive.push(true)
                    }
                }
                retrievedQuestionSoundURLS.push(retrievedQuestion);

                for (let n = 0; n < assignmentsDB[value][i].responseAudio.length; n++) {
                    if (assignmentsDB[value][i].responseAudio[n] === "") {
                        await retrievedCardFlipSound.getDownloadURL().then(url => {
                            retrievedResponse.push(new Audio(url))
                        });
                        tmpSoundsActive.push(false)
                    } else {
                        await allSounds.child(assignmentsDB[value][i].responseAudio[n]).getDownloadURL()
                            .then(url=>{
                                retrievedResponse.push(new Audio(url))
                            })
                        tmpSoundsActive.push(true)
                    }
                }
                retrievedResponseSoundURLS.push(retrievedResponse)


            }

            setQuestionSounds(retrievedQuestionSoundURLS);
            setResponseSounds(retrievedResponseSoundURLS);
            setSoundActive(tmpSoundsActive);
            let tmpFlashCards = (_.times(assignmentsDB[value].length, (i) => (
                <Grid.Column key={i} width={2}>
                    <DialogFlashCard question={assignmentsDB[value][i].question}
                                     response={assignmentsDB[value][i].response}
                                     englishQuestion={assignmentsDB[value][i].englishQuestion}
                                     englishResponse={assignmentsDB[value][i].englishResponse}
                                     questionAudio={retrievedQuestionSoundURLS[i]}
                                     soundActive={tmpSoundsActive[i]}
                                     responseAudio={retrievedResponseSoundURLS[i]}
                    />
                </Grid.Column>)
            ));
            setFlashCards(tmpFlashCards);
            setScrollMenu(
                <ScrollMenu
                    data={tmpFlashCards}
                    arrowLeft={ArrowLeft}
                    arrowRight={ArrowRight}
                    scrollBy={1}
                />
            );
        }

        fetchData().then(() => {
            setLoading(false);
            setAssignmentChosen(true);
        }).catch(e => console.log(e))


    };

    const nextCardQuiz = () => {
        const min = 0;
        const randNum = (min + Math.random() * (assignmentLength - min));
        let randomNumber = Math.floor(randNum);

        setFlashCards([]);


        setFlashCards(
            <Message style={{color: 'white', backgroundColor: 'white', WebkitBoxShadow: 'none'}}>
                <Grid.Column key={rand} width={2}>

                    <DialogFlashCard question={translationAssignment[randomNumber].question}
                                     response={translationAssignment[randomNumber].response}
                                     flipTimer={flipTimer}
                                     startQuiz={true}
                                     englishQuestion={translationAssignment[randomNumber].englishQuestion}
                                     englishResponse={translationAssignment[randomNumber].englishResponse}
                                     soundActive={soundActive[randomNumber]}
                                     questionAudio={translationAssignment[randomNumber].questionAudio}
                                     color="teal"
                                     responseAudio={translationAssignment[randomNumber].responseAudio}
                    />
                </Grid.Column>

            </Message>
        );
        setTimeoutID(setTimeout(() => {
            responseSounds[randomNumber][0].play()
        }, flipTimer));
        setFlipTimer(nextCardTimer / 2);
        questionSounds[randomNumber][0].play()
    };

    const handleStartQuiz = () => {
        setStartQuiz(true);
        setOpen(false);
        nextCardQuiz();
        setIntervalID(setInterval(() => {

            nextCardQuiz()
        }, nextCardTimer));
    };
    const handleStopQuiz = () => {
        setStartQuiz(false);
        setRand(null);
        clearTimeout(timeoutID);
        clearInterval(intervalID);
        setFlashCards(_.times(translationAssignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <DialogFlashCard question={translationAssignment[i].question}
                                 response={translationAssignment[i].response}
                                 flipTimer={null}
                                 englishQuestion={translationAssignment[i].englishQuestion}
                                 englishResponse={translationAssignment[i].englishResponse}
                                 questionAudio={questionSounds[i]}
                                 soundActive={soundActive[i]}
                                 responseAudio={responseSounds[i]}
                                 color="teal"/>
            </Grid.Column>)
        ))
    };

    const handleLanguageChange = (event, {value}) => {
        setSamoanDefault(value)
    };

    const handleDifficultyLevelChange = (event, {value}) => {
        setDifficultyLevel(value)
    };


    const handleSlider = (e) => {
        setNextCardTimer(e.target.value);
        setFlipTimer(nextCardTimer / 2)
    };


    const Arrow = ({text, className}) => {
        return (
            <div onClick={handleArrowButton}
                 className={className}
            >{text}</div>
        );

    };

    const handleArrowButton = () => {
        setFlashCards(_.times(translationAssignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <DialogFlashCard question={translationAssignment[i].question}
                                 response={translationAssignment[i].response}
                                 samoanDefault={samoanDefault}
                                 flipTimer={null}
                                 englishQuestion={translationAssignment[i].englishQuestion}
                                 englishResponse={translationAssignment[i].englishResponse}
                                 soundActive={soundActive[i]}
                                 questionAudio={questionSounds[i]}
                                 responseAudio={responseSounds[i]}
                                 color="teal"/>
            </Grid.Column>)
        ))
    };
    const ArrowLeft = Arrow({text: '<', className: 'arrow-prev'});
    const ArrowRight = Arrow({text: '>', className: 'arrow-next'});

    const updateAssignmentNames = () => {
        CreateRecordingAssignmentOptions(assignmentsDB, 1, 'dialogFCData')
            .then((res) => {
                setAssignmentOptions(res)

            })
    };

    return (
        <>

            <Translate
                assignmentOptions={assignmentOptions}
                flashCards={flashCards}
                handleStartQuiz={handleStartQuiz}
                handleSlider={handleSlider}
                difficultyLevel={difficultyLevel}
                handleDifficultyLevelChange={handleDifficultyLevelChange}
                handleAssignmentChange={handleAssignmentChange}
                handleLanguageChange={handleLanguageChange}
                assignmentNum={assignmentNum}
                samoanDefault={samoanDefault}
                languageOptions={languageOptions}
                startQuiz={startQuiz}
                handleArrowButton={handleArrowButton}
                handleStopQuiz={handleStopQuiz}
                open={open}
                flipTimer={flipTimer}
                nextCardTimer={nextCardTimer}
                setOpen={setOpen}
                ArrowLeft={ArrowLeft}
                ArrowRight={ArrowRight}
                translationFlashCard={false}
                loading={loading}
                scrollMenu={scrollMenu}
                progress={progress}
                progressText={progressText}
                assignmentChosen={assignmentChosen}
                classLevel={classLevel}
                updateAssignmentNames={updateAssignmentNames}
            />
        </>
    )
}

DialogFlashCardWrapper.defaultProps = {
    questionAudio: 'cardflip.mp3',
    responseAudio: 'cardflip.mp3'
};

export default DialogFlashCardWrapper
